import { useAuthContext } from '@/context/AuthContext';
import { useState, useEffect } from 'react';
import { Notification } from './types/Notification';
import { fetchNotifications } from './utils/fetchDataMainteanceBanner';
import NotificationItem from './components/NotificationItem';
import { isEqual } from 'lodash-es';

const POLLING_INTERVAL = 60000;

export default function MaintenanceBanner() {
  const { token } = useAuthContext();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getNotifications = async () => {
    if (!token) {
      return;
    }
    try {
      setError(null);
      const data = await fetchNotifications(token);
      const hasChanges = !isEqual(data, notifications);
      if (hasChanges) {
        setNotifications(data);
      }
    } catch (error) {
      setError('Error fetching notifications');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      getNotifications();
      const intervalId = setInterval(getNotifications, POLLING_INTERVAL);
      return () => clearInterval(intervalId);
    }
  }, [token]);

  if (isLoading) {
    return null;
  }

  if (error) {
    return null;
  }

  if (!notifications?.length) {
    return null;
  }

  return (
    <>
      {Array.isArray(notifications) &&
        notifications.map(notification => (
          <NotificationItem key={`${notification.bannerId}-${notification.createdAt}`} notification={notification} />
        ))}
    </>
  );
}
